<script>
import { Bar } from 'vue-chartjs';
import chartColors from './../libs/chartColors.definition.js';
import currency from './../libs/currency.js';

export default {
    extends: Bar,
    props: ['data'],

    mounted() {
        this.renderBarChart();
    },

    computed: {
        chartData() {
            return this.data;
        },
    },

    watch: {
        data() {
            if (this._chart) {
                this._chart.destroy();
            }
            this.renderBarChart();
        },
    },

    methods: {
        renderBarChart() {
            if (!this.data || this.data.types === undefined) {
                return;
            }

            const self = this;
            const datasets = this.data.types.map((type, i) => {
                switch (type) {
                    case 'line':
                        return {
                            type: 'line',
                            label: this.data.valueLabels[i] || [],
                            data: this.data.values[i] || [],
                            cubicInterpolationMode: 'monotone',
                            tension: 0.4,
                            borderColor: '#000',
                            fill: false,
                            pointStyle: 'circle',
                            pointRadius: 5,
                            pointHoverRadius: 7,
                            backgroundColor: '000',
                        };
                    default:
                        return {
                            type: 'bar',
                            label: this.data.valueLabels[i] || [],
                            data: this.data.values[i] || [],
                            color: '#fff',
                            backgroundColor:
                                chartColors[this.data.showAverage ? i - 1 : i],
                        };
                }
            });

            this.renderChart(
                {
                    labels: this.data.labels || [],
                    datasets,
                },
                {
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero: true,
                                },
                                gridLines: {
                                    display: true,
                                },
                                stacked: true,
                            },
                        ],
                        xAxes: [
                            {
                                ticks: {
                                    display: true,
                                },
                                stacked: true,
                            },
                        ],
                    },
                    legend: {
                        display: true,
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, data) {
                                const datasetIndex = tooltipItem.datasetIndex;
                                const dataIndex = tooltipItem.index;
                                const tooltipData = data.datasets[datasetIndex];
                                const label = tooltipData.label;
                                let value = tooltipData.data[dataIndex];
                                switch (self.data.format) {
                                    case 'CURRENCY':
                                        value = currency(
                                            value,
                                            self.data.currency
                                        );
                                        break;
                                }
                                return `${label}: ${value}`;
                            },
                        },
                        backgroundColor: '#FFF',
                        titleFontColor: '#09b3af',
                        bodyFontColor: '#000',
                        borderColor: '#09b3af',
                        borderWidth: 1,
                        displayColors: false,
                    },
                }
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// ChartBarAndLine.vue?b361cbe2